"use client";

import Spinner from "@/components/ui/spinner";
import { animatePageIn } from "@/lib/pageAnimate";
import { useParams, usePathname } from "next/navigation";
import React, { useEffect } from "react";

function Template({ children }: Readonly<{ children: React.ReactNode }>) {
  const params = useParams();
  const pathName = usePathname();

  useEffect(() => {
    animatePageIn();
  }, [params, pathName]);

  return (
    <div>
      <div
        id={`banner-1`}
        className="fixed left-0 top-0 z-50 min-h-screen w-1/4 bg-slate-900"
      ></div>
      <div
        id={`banner-2`}
        className="fixed left-1/4 top-0 z-50 min-h-screen w-1/4 bg-slate-900"
      ></div>
      <div
        id={`banner-3`}
        className="fixed left-2/4 top-0 z-50 min-h-screen w-1/4 bg-slate-900"
      ></div>
      <div
        id={`banner-4`}
        className="fixed left-3/4 top-0 z-50 min-h-screen w-1/4 bg-slate-900"
      ></div>
      <div
        id={"banner-loader"}
        className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 transform"
      >
        <Spinner />
      </div>
      {children}
    </div>
  );
}

export default Template;
